import React from 'react';
import { Avatar as AntdAvatar } from 'antd';
import PropTypes from 'prop-types';

// Default Variant
const defaultAvatarSize = 24;
const defaultTextSize = 12;
const defaultLineHeight = 18;

// Large Variant
const largeAvatarSize = 32;
const largeTextSize = 14;
const largeLineHeight = 20;

// Common properties
const backgroundColor = '#D5F2F6';
const color = '#3D3D3D';
const fontWeight = 700;

export const getInitialsForAvatar = (name) => {
  if (!name) {
    return '';
  }

  if (typeof name !== 'string') {
    return '';
  }

  const fullName = name.split(' ');

  if (fullName.length === 1) {
    return name.charAt(0);
  }

  const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
  return initials.toUpperCase();
};

const Avatar = ({ children, large }) => {
  const size = large ? largeAvatarSize : defaultAvatarSize;
  const fontSize = large ? largeTextSize : defaultTextSize;
  const lineHeight = large ? largeLineHeight : defaultLineHeight;
  const label = getInitialsForAvatar(children);

  return (
    <AntdAvatar style={{ backgroundColor, color, fontSize, fontWeight, lineHeight }} size={size}>
      {label}
    </AntdAvatar>
  );
};

Avatar.propTypes = {
  children: PropTypes.string.isRequired,
  large: PropTypes.bool,
};

export { Avatar };
